<dx-popup
  [showTitle]="true"
  [title]="dialogTitle"
  [(visible)]="displayDialog"
  [width]="1500"
  [height]="700"
  [showCloseButton]="true"
  [fullScreen]="fullScreenDialog"
  (onHiding)="closeDialog()">
  <dxi-toolbar-item
    widget="dxButton"
    location="after"
    [options]="{
            icon: 'fullscreen',
            onClick: toggleFullScreenInvoice
        }">
  </dxi-toolbar-item>

  <div class="dialog-line text-right">
    <div class="col-lg-12">
      @if (!utilsSvc.isIdInit(factureClient?.id)) {
        <yo-button
          [theme]="ButtonThemeEnum.DEFAULT"
          label="Générer la facture"
          tooltip="Générer la facture"
          (onClick)="generateFacture()"
          class="mg-r-5">
        </yo-button>
      }
      @if (utilsSvc.isIdInit(factureClient?.id)) {
        <yo-button
          [theme]="ButtonThemeEnum.DEFAULT"
          tooltip="Imprimer la facture"
          (onClick)="printFacture()"
          class="mg-r-5"
          iconClass="fas fa-print">
        </yo-button>
      }
    </div>
  </div>

  <div class="dialog-line">
    <div class="col-lg-12">
      <table class="lignes-facture-table">
        <thead>
        <tr>
          <th>Numéro de facture</th>
          <th>Point de facturation</th>
          <th>Date de facturation</th>
          <th>Date d'échéance</th>
          <th>Date début</th>
          <th>Date fin</th>
          <th>Quantité</th>
          <th>Total HT</th>
          <th>Total TTC</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{ factureClient?.numeroFacture }}</td>
          <td>{{ factureClient?.pointFacturation?.libelle }}</td>
          <td>{{ utilsSvc.formatDate(factureClient?.dateFacturation) }}</td>
          <td>{{ utilsSvc.formatDate(factureClient?.dateEcheance) }}</td>
          <td>{{ utilsSvc.formatDate(factureClient?.dateDebut) }}</td>
          <td>{{ utilsSvc.formatDate(factureClient?.dateFin) }}</td>
          <td>{{ factureClient?.quantite }}</td>
          <td>{{ factureClient?.montantHT?.value }} {{ factureClient?.montantHT?.uniteMonetaire }}</td>
          <td>{{ factureClient?.montantTTC?.value }} {{ factureClient?.montantTTC?.uniteMonetaire }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  @if (factureClient?.plcFraisFixeAuServiceList?.length) {
    <div class="dialog-line">
      <div class="col-lg-12">
        <table class="lignes-facture-table">
          <thead>
          <tr>
            <th>Point de livraison</th>
            <th>Frais fixe</th>
            <th>Frais fixes (Au service) HT</th>
            <th>TVA</th>
            <th>Frais fixes (Au service) TTC</th>
          </tr>
          </thead>
          <tbody>
          @for (plcFF of factureClient.plcFraisFixeAuServiceList; track plcFF.codePlc + '_' + plcFF.codeFraisFixe) {
            <tr>
              <td>{{ plcFF.libellePlc }}</td>
              <td>{{ plcFF.libelleFraisFixe }}</td>
              <td>{{ plcFF.montantHT?.value }} {{ plcFF.montantHT?.uniteMonetaire }}</td>
              <td>{{ plcFF.tauxTva }} %</td>
              <td>{{ plcFF.montantTTC?.value }} {{ plcFF.montantTTC?.uniteMonetaire }}</td>
            </tr>
          }
          </tbody>
        </table>
      </div>
    </div>
  }

  @if (lignesDisplay?.length) {
    <div class="dialog-line remaining-space">
      <dx-data-grid
        [dataSource]="lignesDisplay"
        keyExpr="rowKey"
        width="100%"
        height="490"
        [hoverStateEnabled]="true"
        [allowColumnResizing]="true"
        [rowAlternationEnabled]="false"
        [showRowLines]="true"
        [showBorders]="true"
        (onRowPrepared)="onRowPrepared($event)">
        <dxi-column dataField="libellePlc" caption="Point de livraison"></dxi-column>
        <dxi-column dataField="libellePrincipal" caption="Libellé facturé"></dxi-column>
        <dxi-column dataField="libellePrestation" caption="Prestation"></dxi-column>
        <dxi-column dataField="libelleRepas" caption="Repas"></dxi-column>
        <dxi-column dataField="libelleRegime" caption="Régime"></dxi-column>
        @if (factureClient?.typeFactureClient === TypeFactureClientEnum.FACTURE_CLIENT_FAMILLE_FACTURATION) {
          <dxi-column dataField="libelleFamilleFacturation" caption="Famille de facturation"></dxi-column>
        }
        <dxi-column dataField="quantite" caption="Quantité" alignment="left"></dxi-column>
        <dxi-column dataField="montantUnitaire" caption="PU HT" cellTemplate="prixCellTemplate"></dxi-column>
        <dxi-column dataField="montantHT" caption="Montant HT" cellTemplate="prixCellTemplate"></dxi-column>
        <dxi-column dataField="tauxTVA" caption="TVA" alignment="left" cellTemplate="tvaCellTemplate"></dxi-column>
        <dxi-column dataField="montantTTC" caption="Montant TTC" cellTemplate="prixCellTemplate"></dxi-column>

        <div *dxTemplate="let cell of 'prixCellTemplate'">
          {{ cell.value?.value }} {{ cell.value?.uniteMonetaire }}
        </div>

        <div *dxTemplate="let cell of 'tvaCellTemplate'">
          @if (cell?.value != null) { {{ cell.value }} % }
        </div>

        <dxo-pager
          [showPageSizeSelector]="true"
          [showNavigationButtons]="false"
          [allowedPageSizes]="[20, 50, 100, 200]"
          [visible]="true"
          [showInfo]="true"
          infoText="{2} ligne(s)">
        </dxo-pager>
      </dx-data-grid>
    </div>
  }
</dx-popup>
